import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Checkbox } from "Components/Base/Inputs/Checkbox";

const CheckboxAdministrator = ({
  id,
  value,
  lang,
  onToggle,
  type, // 'participant' or 'administrator'
}) => {
  const isParticipant = type === "participant";
  const label = isParticipant
    ? "hideParticipantCourses"
    : "hideAdministratorCourses";

  return (
    <BaseGrid childWidth="auto" alignItems="center">
      <Checkbox
        id={id}
        color="secondary"
        checked={!!value}
        onChange={(e) => {
          let hideAdministratorCourses;
          let hideParticipantCourses;

          if (isParticipant) {
            hideParticipantCourses = !value;
            hideAdministratorCourses = false;
          } else {
            hideAdministratorCourses = !value;
            hideParticipantCourses = false;
          }

          onToggle({
            hideParticipantCourses,
            hideAdministratorCourses,
          });
        }}
        fontSize="14px"
        label={lang(label)}
      />
    </BaseGrid>
  );
};

export default CheckboxAdministrator;
